import { baseApi } from './baseApi'
import type {
  DataResponse,
  MessageResponse,
  PageResponse,
  Vendor,
  VendorListQuery,
} from '@/types/api'

export const vendorsApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    listVendors: b.query<PageResponse<Vendor>, VendorListQuery | void>({
      query: (params) => ({ url: '/vendors/list', params: params ?? {} }),
      providesTags: (res) =>
        res
          ? [
              ...res.items.map((v) => ({ type: 'Vendor' as const, id: v.code })),
              { type: 'Vendor' as const, id: 'LIST' },
            ]
          : [{ type: 'Vendor' as const, id: 'LIST' }],
    }),
    getVendor: b.query<DataResponse<Vendor>, string>({
      query: (code) => `/vendors/${encodeURIComponent(code)}`,
      providesTags: (_r, _e, code) => [{ type: 'Vendor', id: code }],
    }),
    createVendor: b.mutation<DataResponse<Vendor>, Vendor>({
      query: (body) => ({ url: '/vendors/create', method: 'POST', body }),
      invalidatesTags: [{ type: 'Vendor', id: 'LIST' }],
    }),
    updateVendor: b.mutation<DataResponse<Vendor>, { code: string; body: Partial<Vendor> }>({
      query: ({ code, body }) => ({
        url: `/vendors/${encodeURIComponent(code)}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_r, _e, arg) => [
        { type: 'Vendor', id: arg.code },
        { type: 'Vendor', id: 'LIST' },
      ],
    }),
    deleteVendor: b.mutation<MessageResponse, string>({
      query: (code) => ({ url: `/vendors/${encodeURIComponent(code)}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'Vendor', id: 'LIST' }],
    }),
  }),
})

export const {
  useListVendorsQuery,
  useGetVendorQuery,
  useCreateVendorMutation,
  useUpdateVendorMutation,
  useDeleteVendorMutation,
} = vendorsApi
